import {
    createGroup,
    deleteGroup,
    generateLicenses,
    revokeLicense,
    updateGroupMembers,
    updateGroupParent,
} from "@dashboard/devices/store";
import { policiesApi } from "@dashboard/policies/api";
import { productsApi } from "@dashboard/products/api";
import { createProvisioning, deleteProvisioning } from "@dashboard/provisioning/store";
import { fdroidsApi } from "@dashboard/repositories/api";
import { isAnyOf, ListenerMiddlewareInstance, UnsubscribeListener } from "@reduxjs/toolkit";

import { workspacesApi } from ".";

const workspacesActions = isAnyOf(
    updateGroupMembers.fulfilled,
    deleteGroup.fulfilled,
    createGroup.fulfilled,
    updateGroupParent.fulfilled,
    createProvisioning.fulfilled,
    deleteProvisioning.fulfilled,
    generateLicenses.fulfilled,
    revokeLicense.fulfilled,
    policiesApi.endpoints.createPolicy.matchFulfilled,
    policiesApi.endpoints.deletePolicy.matchFulfilled,
    productsApi.endpoints.createProduct.matchFulfilled,
    productsApi.endpoints.deleteProduct.matchFulfilled,
    productsApi.endpoints.createBuild.matchFulfilled,
    productsApi.endpoints.deleteBuild.matchFulfilled,
    productsApi.endpoints.importProductBuild.matchFulfilled,
    fdroidsApi.endpoints.createFdroid.matchFulfilled,
    fdroidsApi.endpoints.deleteFdroid.matchFulfilled,
);

export const initWorkspacesCacheListener = (listenerMiddleware: ListenerMiddlewareInstance): UnsubscribeListener => {
    return listenerMiddleware.startListening({
        matcher: workspacesActions,
        effect: (_action, listenerApi) => {
            listenerApi.dispatch(workspacesApi.util.invalidateTags(["Workspaces", "WorkspaceFeatures"]));
        },
    });
};
